// extracted by mini-css-extract-plugin
export default {"title":"Upsell_title__EjsEh","container":"Upsell_container__LUvN5","info":"Upsell_info__OcCfV","description":"Upsell_description__MuVaA","icon":"Upsell_icon__bdA2X"};